module.exports = __webpack_public_path__ + "static/media/mobile5.bb5195e1.png";